import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import './ComingSoon.css';

export const ComingSoon = ({ title, blurb }) => {
  const reduced = useReducedMotion();
  return (
    <div className="coming-page">
      <div className="coming-glow" aria-hidden="true" />
      <motion.div
        className="coming-inner"
        initial={{ opacity: 0, y: reduced ? 0 : 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: reduced ? 0.2 : 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <span className="coming-chip">Coming Soon</span>
        <h1 className="coming-title">{title}</h1>
        <p className="coming-blurb">{blurb}</p>
        <div className="coming-cta">
          <Link to="/contact" className="btn-primary">Book a Scoping Call <ArrowRight size={18} /></Link>
          <Link to="/" className="btn-secondary">Back home</Link>
        </div>
      </motion.div>
    </div>
  );
};
